var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "551",
        height: "551",
        viewBox: "0 0 551 551",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_1_2)" } }, [
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M275.5 220.4V275.5H330.6C330.6 245.057 305.943 220.4 275.5 220.4ZM275.5 110.2V165.3C336.275 165.3 385.7 214.725 385.7 275.5H440.8C440.8 184.199 366.801 110.2 275.5 110.2ZM275.5 0V55.1C397.023 55.1 495.9 153.977 495.9 275.5H551C551 123.341 427.659 0 275.5 0ZM403.663 502.344C403.359 503.198 403.332 503.335 403.663 502.344ZM388.923 429.177C369.776 418.874 350.408 407.133 330.379 398.95C291.672 383.164 294.289 429.832 266.656 444.957C248.694 454.792 223.348 436.969 207.672 427.106C180.287 409.859 156.016 387.163 135.849 360.908C125.518 347.491 102.706 322.257 105.516 303.44C109.98 273.576 145.299 272.078 135.188 235.547C129.788 215.987 120.118 196.735 112.872 177.891C103.175 152.628 99.1798 136.453 70.886 137.831C50.4439 138.823 36.8894 147.563 24.3266 163.955C-9.67007 208.228 -4.54582 267.918 18.2931 316.489C50.6368 385.226 106.067 450.029 165.272 491.905C205.55 520.391 258.612 546.256 307.375 550.637C343.08 553.86 393.028 534.555 405.811 495.792C404.93 498.492 404.076 501.104 403.663 502.344C403.966 501.379 404.627 499.429 405.811 495.792C407.106 491.88 407.74 489.921 408.043 489.039C407.657 490.197 406.776 492.902 405.839 495.712C417.079 461.55 418.457 445.074 388.923 429.177ZM408.043 489.039C408.263 488.378 408.263 488.323 408.043 489.039Z",
            fill: "#5021D1",
          },
        }),
      ]),
      _vm._v(" "),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_1_2" } }, [
          _c("rect", { attrs: { width: "551", height: "551", fill: "white" } }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }